import { IKenloPropertyFilterOption, IKenloPaymentsData, IPayment } from "../types/ownerDashboard.types";
import { isGenericPropertyLabel, normalizeKenloPropertyId } from "./buildPropertyLabelMap";
import { KenloPropertyOption, getKenloPropertyOptions } from "./getKenloPropertyOptions";

export function normalizeKenloPayment(payment: IPayment): IPayment {
  const propertyLabel = payment.property_label?.trim();

  return {
    ...payment,
    kenlo_property_id: normalizeKenloPropertyId(payment.kenlo_property_id),
    property_label: propertyLabel && !isGenericPropertyLabel(propertyLabel) ? propertyLabel : null,
  };
}

export function normalizeKenloPropertyFilterOptions(
  options: IKenloPropertyFilterOption[] | null | undefined
): IKenloPropertyFilterOption[] {
  if (!Array.isArray(options)) {
    return [];
  }

  return options
    .map((option) => {
      const kenloPropertyId = normalizeKenloPropertyId(option.kenlo_property_id);
      const propertyLabel = option.property_label?.trim();

      if (!kenloPropertyId || !propertyLabel || isGenericPropertyLabel(propertyLabel)) {
        return null;
      }

      return {
        kenlo_property_id: kenloPropertyId,
        property_label: propertyLabel,
      };
    })
    .filter((option): option is IKenloPropertyFilterOption => option != null);
}

export function mapKenloPropertyFilterOptions(
  options: IKenloPropertyFilterOption[] | null | undefined
): KenloPropertyOption[] {
  return normalizeKenloPropertyFilterOptions(options).map((option) => ({
    kenloPropertyId: option.kenlo_property_id,
    label: option.property_label,
  }));
}

export function normalizeKenloPaymentsData(data: IKenloPaymentsData): IKenloPaymentsData {
  return {
    ...data,
    payments: (data.payments ?? []).map(normalizeKenloPayment),
    property_filter_options: normalizeKenloPropertyFilterOptions(data.property_filter_options),
  };
}

export function resolveKenloPropertyFilterOptions(
  apiOptions: IKenloPropertyFilterOption[] | null | undefined,
  payments: IPayment[] = []
): KenloPropertyOption[] {
  const fromApi = mapKenloPropertyFilterOptions(apiOptions);

  if (fromApi.length > 0) {
    return fromApi;
  }

  return getKenloPropertyOptions(payments);
}
